import { useContext } from 'react';
import FeatureContext, { FeatureData } from './FeatureContext';
import { FeatureFlags } from '../../types';

function useFeatures(defaultValue = {}): FeatureFlags | undefined {
  const context = useContext<FeatureData>(FeatureContext);

  if (context === undefined) {
    throw new Error('useFeatures: FeatureProvider missing');
  }

  return context.features || defaultValue;
}

export default useFeatures;
